module.exports = __webpack_public_path__ + "static/media/fhl.701a9111.png";